import store from '../store'
import { browserHistory } from 'react-router';

export const redirectToLogin = () => {
    store.dispatch({"type":"CHANGE_LOGIN_STATUS", payload:0 })
    localStorage.clear();
    browserHistory.push('login')
    return true;
}